// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/51fe94bc941ffe1ed2c1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"aa1426f1386cddc7c28d","174":"4acddac11729eaad4c22","175":"a3b8ef26005ca593f3e4"}[chunkId] + ".chunk.js";
};